import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Area } from '@/enums/Area.enum';
import { Style } from 'ol/style';
import { LayerName } from '@/enums/LayerName.enum';
import { FILL_TRANSPARENT, STROKE_WHITE_W1 } from '@/utils/constants.utils';

import data from '@/data/balkan.data.json';

const style = new Style({
	fill: FILL_TRANSPARENT,
	stroke: STROKE_WHITE_W1,
});

export const balkanLayer = new VectorLayer({
	visible: true,
	source: new VectorSource({
		features: new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:3857' }),
	}),
	style,
});

balkanLayer.setProperties({ area: Area.BALKAN, name: LayerName.BALKAN });
